import * as handler from './handler';
import { PATH_COUNTRIES } from './path';

const getCountries = () =>
  handler.get(PATH_COUNTRIES).then((res) => {
    return res;
  });

export default { getCountries };
